import { Root_default } from "./chunk-6GC4FAYO.js";
import { TransitionComponent } from "./chunk-QUQRJRHE.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Dialog/Dialog.tsx
import { Fragment } from "react";
import clsx from "clsx";
import { Dialog as HeadlessDialog } from "@headlessui/react";
import { jsx } from "react/jsx-runtime";
var DIALOG_CLASSNAME_MAP = {
  size: {
    sm: "pd:dialog--sm",
    md: "pd:dialog--md",
    lg: "pd:dialog--lg"
  }
};
var Dialog = _a => {
  var _b = _a,
    {
      isOpen,
      size = "md",
      children,
      className
    } = _b,
    rest = __objRest(_b, ["isOpen", "size", "children", "className"]);
  return (
    // Adding <Root> because the Dialog is rendered in a React Portal, so it's outside of the usual <Root>
    /* @__PURE__ */
    jsx(TransitionComponent, {
      show: isOpen,
      as: Fragment,
      children: /* @__PURE__ */jsx(Root_default, __spreadProps(__spreadValues({
        as: HeadlessDialog
      }, rest), {
        children: /* @__PURE__ */jsx("section", {
          className: clsx("pd:dialog", DIALOG_CLASSNAME_MAP.size[size], className),
          children
        })
      }))
    })
  );
};
var Dialog_default = Dialog;
export { Dialog_default };